import { __awaiter, __generator } from "tslib";
import { logError } from '@office-start/telemetry-service';
// Save a value to local storage, returns promise that resolves when the value is saved
export function saveToLocalStorage(key, value) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    try {
                        if (typeof Windows !== 'undefined' &&
                            typeof Windows.Storage.ApplicationData !== 'undefined') {
                            Windows.Storage.ApplicationData.current.localSettings.values.insert(key, value);
                            resolve();
                            return;
                        }
                        reject();
                    }
                    catch (err) {
                        logError({
                            eventName: 'SaveToLocalStorage',
                            message: "Error in saveToLocalStorage: ".concat(err),
                        });
                        reject();
                    }
                })];
        });
    });
}
// Retrieve a value from local storage, returns undefined if the key is not found or error occurs
export function getFromLocalStorage(key) {
    return new Promise(function (resolve, reject) {
        try {
            if (typeof Windows !== 'undefined' &&
                typeof Windows.Storage.ApplicationData !== 'undefined') {
                resolve(Windows.Storage.ApplicationData.current.localSettings.values.lookup(key));
                return;
            }
            reject();
        }
        catch (err) {
            logError({
                eventName: 'GetFromLocalStorage',
                message: "Error in getFromLocalStorage: ".concat(err),
            });
            reject();
        }
    });
}
//# sourceMappingURL=localStorage.js.map